import { Card } from "../components/Card";
export default function Location() {
  return (
    <>
      <Card id="location" className="location" bgc="fill" title="Conner Family Reunion 2025 Location">
        <div className="callout">
          <div className="address">
            <div>Pomona Christian Church</div>
            <div>5040 County Road 1390, Pomona, Missouri</div>
          </div>
          <div className="map">
            <iframe className="mapframe" title="locationmap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.380770549018!2d-91.9121477874765!3d36.869725372102785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d05ea0cbc12e43%3A0x785da49ce3b77658!2s5040%20Co%20Rd%201390%2C%20Pomona%2C%20MO%2065789!5e0!3m2!1sen!2sus!4v1726521586792!5m2!1sen!2sus" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
        <p>
          We are excited to be hosting the reunion in the same location this year, as we voted on at 
          the last reunion. On <strong>Saturday, June 21</strong>, we will be meeting at Pomona 
          Christian Church in Pomona, Missouri. We have reserved the gym, “living room” (lobby 
          area with couches and tables), and commercial kitchen for the entire day. We will also 
          have access to an outdoor playground and large grassy areas for outdoor games and 
          activities. The address is 5040 County Road 1390, Pomona, Missouri. It’s located just 
          off Highway 63 between Willow Springs and West Plains.
        </p>
        <p>
          On <strong>Sunday, June 22</strong>, we are still trying to determine the best place 
          to meet.  Last reunion, I know it was pretty hot at the park pavilion.  There is 
          a <a href="https://www.hilton.com/en/hotels/tbnwphx-hampton-west-plains/" target="connertab">meeting room</a> at 
          the hotel that we could reserve.  They have provided these statistics on the size and 
          occupancy rating for the room:
        </p>
        <table className="dataTable">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Room size</td>
              <td>
                600 sq ft<br/>
                (approx 20' x 30')
              </td>
            </tr>
            <tr>
              <td>Dining setup</td>
              <td>39 people</td>
            </tr>
            <tr>
              <td>Classroom setup</td>
              <td>50 people</td>
            </tr>
            <tr>
              <td>Theatre setup</td>
              <td>79 people</td>
            </tr>
          </tbody>
        </table>
        <p>
          Based on the turnout we had on the Sunday of the last reunion, this meeting room looks like 
          it would suffice for us.  Plus, if we have lunch there Sunday, we might be able to spill over
          into the seating area for the hotel used for breakfast.
        </p>
        <p>
          Check back later to see if we have been able to secure a meeting place for Sunday.
        </p>
      </Card>
    </>

  );

}